// Copyright (c) 2016 Deere & Company

import KeyValuePair from '../../../../sharedmodules/state/key-value-pair';
import t from 'tcomb';

const Division = t.list(KeyValuePair, 'division');

export const getDefaultState = () => new Division([]);

export default Division;
